import RequestService from '../service/requestService';
import { RoleServiceInstance } from '../service/roleService';

import {
  SAVING_ASSIGNEMENT,
  SAVED_ASSIGNEMENT,
  DELETING_ASSIGNEMENT,
  DELETE_ASSIGNEMENT_ERROR,
  SAVE_ASSIGNEMENT_ERROR,
  FETCHING_ROLES,
  RECEIVED_ROLES,
  RECEIVED_ROLES_ERROR,
  VALIDATION_ERROR,
  RECEIVED_USER_ROLES_FOR_SPONSOR,
  RECEIVED_USER_ROLES_FOR_SPONSOR_ERROR,
  PUBLISH_PERMISSION_MATRIX,
  USER_ASSIGNMENTS__FETCH,
  DATA_LOADING,
  DATA_ERROR,
  UPDATING_PHI_CONSENT,
  UPDATE_PHI_CONSENT,
  UPDATING_PHI_CONSENT_FAILED,
  LOGGED_USER_FETCH,
  LOGGED_USER_FETCH_ERROR
} from './actionTypes';

import { receivedUnassignedStudies } from './studies.actions';

export const clearValidationError = () => {
  return {
    type: VALIDATION_ERROR,
    payload: null
  };
};

export const validationError = (data) => {
  return {
    type: VALIDATION_ERROR,
    payload: data
  };
};

export const savingAssignment = () => {
  return {
    type: SAVING_ASSIGNEMENT
  };
};

function fetchActive(userId, sponsor) {
  return RequestService.getUserAssignments(userId, sponsor);
}

export const fetchedLoggedUser = (assignments) => {
  return {
    type: LOGGED_USER_FETCH,
    payload: assignments
  };
};

export const fetchedLoggedUserError = (error) => {
  return {
    type: LOGGED_USER_FETCH_ERROR,
    payload: error
  };
};

function refreshAssignmentsOnSuccess(assignmentPersisted, userId, sponsor) {
  return (dispatch) => {
    return Promise.all([fetchActive(userId, sponsor)]).then(
      (responseAll) => {
        dispatch(savedAssignment(assignmentPersisted));
        dispatch(fetchedAssignments(responseAll[0]));
        dispatch(receivedUnassignedStudies(responseAll[1].data.studies.data));
      },
      (error) => {
        dispatch(saveAssignmentError(error));
      }
    );
  };
}

function refreshAssignmentsOnError(error, userId, sponsor) {
  return (dispatch) => {
    return Promise.all([fetchActive(userId, sponsor)]).then(
      (responseAll) => {
        dispatch(saveAssignmentError(error));
        dispatch(fetchedAssignments(responseAll[0]));
        dispatch(receivedUnassignedStudies(responseAll[1].data.studies.data));
      },
      (error) => {
        dispatch(saveAssignmentError(error));
      }
    );
  };
}

export function saveAssignmentAndUpdateUnassignedStudies(model) {
  const { assignment, userId } = model;
  const { sponsorGid } = assignment;

  return (dispatch) => {
    dispatch(savingAssignment());
    return RequestService.saveAssignment(userId, model).then(
      (response) => {
        dispatch(refreshAssignmentsOnSuccess(response.data, userId, sponsorGid));
      },
      (error) => {
        dispatch(saveAssignmentError(error));
      }
    );
  };
}

export function updateAssignmentsAndStudies(assignmentId, model) {
  const { assignment, userId } = model;
  const { sponsorGid } = assignment;

  return (dispatch) => {
    dispatch(savingAssignment());
    return RequestService.updateAssignment(assignmentId, model).then(
      (response) => {
        dispatch(refreshAssignmentsOnSuccess(response.data, userId, sponsorGid));
      },
      (error) => {
        dispatch(refreshAssignmentsOnError(error, userId, sponsorGid));
      }
    );
  };
}

export function deleteAssignment(assignmentId, userId, sponsor, payload) {
  return (dispatch) => {
    dispatch(deletingAssignment(true));
    return RequestService.deleteAssignment(assignmentId, sponsor, payload)
      .then(() => {
        Promise.all([fetchActive(userId, sponsor)]).then(
          (responseAll) => {
            dispatch(deletingAssignment(false));
            dispatch(fetchedAssignments(responseAll[0]));
            dispatch(receivedUnassignedStudies(responseAll[1].data.studies.data));
          },
          (error) => {
            dispatch(deleteAssignmentError(error));
          }
        );
      })
      .catch((error) => {
        Promise.all([fetchActive(userId, sponsor)]).then(
          (responseAll) => {
            dispatch(deleteAssignmentError(error));
            dispatch(fetchedAssignments(responseAll[0]));
            dispatch(receivedUnassignedStudies(responseAll[1].data.studies.data));
          },
          (error) => {
            dispatch(saveAssignmentError(error));
          }
        );
      });
  };
}

export function fetchLoggedUserDetails(userId, sponsor) {
  return function (dispatch) {
    RequestService.getUserAssignments(userId, sponsor)
      .then((response) => dispatch(fetchedLoggedUser(response)))
      .catch((error) => dispatch(fetchedLoggedUserError(error)));
  };
}

export const deletingAssignment = (status) => {
  return {
    type: DELETING_ASSIGNEMENT,
    payload: status
  };
};

export const deleteAssignmentError = (err) => {
  return {
    type: DELETE_ASSIGNEMENT_ERROR,
    payload: err
  };
};

export const savedAssignment = (assignment) => {
  return {
    type: SAVED_ASSIGNEMENT,
    payload: assignment
  };
};

export const saveAssignmentError = (error) => {
  return {
    type: SAVE_ASSIGNEMENT_ERROR,
    payload: error
  };
};

export const fetchingRoles = () => {
  return {
    type: FETCHING_ROLES
  };
};

export const receivedRoles = (roles) => {
  return {
    type: RECEIVED_ROLES,
    payload: roles
  };
};

export const fetchRolesError = (error) => {
  return {
    type: RECEIVED_ROLES_ERROR,
    payload: error
  };
};

export const updatingCanConsentAndPhi = () => {
  return {
    type: UPDATING_PHI_CONSENT
  };
};

export const updateCanConsentAndPhi = (updatedRowData) => {
  return {
    type: UPDATE_PHI_CONSENT,
    payload: updatedRowData
  };
};

export const updatingCanConsentAndPhiFailed = (updatedRowData) => {
  return {
    type: UPDATING_PHI_CONSENT_FAILED,
    payload: updatedRowData
  };
};

export function fetchRoles(sponsor) {
  return (dispatch) => {
    dispatch(fetchingRoles());
    return RequestService.getRoles(sponsor)
      .then((response) => {
        dispatch(receivedRoles(response.data));
      })
      .catch((error) => {
        dispatch(fetchRolesError(error));
      });
  };
}

export const receivedUserRolesForSponsor = (roles) => {
  return {
    type: RECEIVED_USER_ROLES_FOR_SPONSOR,
    payload: roles
  };
};

export const fetchUserRolesForSponsorError = (error) => {
  return {
    type: RECEIVED_USER_ROLES_FOR_SPONSOR_ERROR,
    payload: error
  };
};

export const publishPermissionMatrix = (matrix) => {
  return {
    type: PUBLISH_PERMISSION_MATRIX,
    payload: matrix
  };
};

export const processUserRoles = (userRoles) => {
  return (dispatch) => {
    const matrix = RoleServiceInstance.getMatrix(userRoles.roles.data);
    dispatch(publishPermissionMatrix(matrix));
    dispatch(receivedUserRolesForSponsor(userRoles.roles.data));
  };
};

export function fetchAssignments(userId, sponsor) {
  return function (dispatch) {
    dispatch(loading());
    return RequestService.getUserAssignments(userId, sponsor)
      .then((response) => {
        dispatch(fetchedAssignments(response));
      })
      .catch((error) => {
        dispatch(errorHandler(error));
      });
  };
}

export function clearRoleManagementErrors() {
  return (dispatch) => {
    dispatch(errorHandler(null));
  };
}

export const fetchedAssignments = (assignments) => {
  return {
    type: USER_ASSIGNMENTS__FETCH,
    payload: assignments
  };
};

export const loading = () => {
  return {
    type: DATA_LOADING
  };
};
export const errorHandler = (error) => {
  return {
    type: DATA_ERROR,
    payload: error
  };
};
